var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeaksDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1800 241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00527c;\n      }\n\n      .cls-2 {\n        fill: #2ebee4;\n      }\n\n      .cls-3 {\n        fill: #1894be;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visual"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,68L113,0l112,45,113,10,112-16,113,38,112-61,113,63,112-66v228H0V68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,46l113,63,112-74,113,81,112-27,113-21,112,10,113,23,112-5v145H0V46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,120l113-43,112,38,113,21,112,4,113-29,112,16,113-42,112,15v141H0v-121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,158l113-13,112,14,113-25,112,46,113-10,112-49h113l112,44v76H0v-83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,166l113,33,112-25,113,5,112,15,113,4,112,12,113-19,112-15v65H0v-75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1800,241h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0V13s112,66,112,66l113-63,112,61,113-38,112,16,113-10L1687,0l113,68v173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1800,241h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0V96s112,5,112,5l113-23,112-10,113,21,112,27,113-81,112,74,113-63v195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1800,241h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0V100s112-15,112-15l113,42,112-16,113,29,112-4,113-21,112-38,113,43v121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1800,241h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0v-76s112-44,112-44h113s112,49,112,49l113,10,112-46,113,25,112-14,113,13v83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1800,241h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0h-113s-112,0-112,0v-65s112,15,112,15l113,19,112-12,113-4,112-15,113-5,112,25,113-33v75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaksDouble);
export default __webpack_public_path__ + "static/media/peaks_double.a507761cfe51f9de59e8b3cb742fcd15.svg";
export { ForwardRef as ReactComponent };